"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");exports.__esModule=true;exports.default=void 0;var _exponent=_interopRequireDefault(require("./exponent"));var precisionPrefix=function precisionPrefix(step,value){return Math.max(0,Math.max(-8,Math.min(8,Math.floor((0,_exponent.default)(value)/3)))*3-(0,_exponent.default)(Math.abs(step)))};var _default=precisionPrefix;exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/utils/src/number-converter/precision-prefix.js
// module id = 418Q
// module chunks = 5